/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CertificateIssuedViewModel } from "../types/CertificateIssuedViewModel.ts";
import { eTypeCertificateSchema } from "./eTypeCertificateSchema.ts";

export const certificateIssuedViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do certificado emitido.")),
  hash: z
    .string()
    .describe("Código hash único de autenticidade do certificado emitido.")
    .nullish(),
  certificateId: z.optional(
    z
      .number()
      .int()
      .describe("ID do template de certificado utilizado na emissão."),
  ),
  issueDate: z.optional(
    z.string().datetime().describe("Data de emissão do certificado."),
  ),
  personId: z.optional(
    z
      .number()
      .int()
      .describe("ID da pessoa para quem o certificado foi emitido."),
  ),
  personName: z
    .string()
    .describe("Nome da pessoa para quem o certificado foi emitido.")
    .nullish(),
  description: z
    .string()
    .describe("Descrição do certificado emitido.")
    .nullish(),
  typeCertificate: z.optional(
    z
      .lazy(() => eTypeCertificateSchema)
      .describe(
        "0 = MonographAdvise | 1 = MonographBoardMember | 2 = MonographDefense | 3 = FinishCourse | 4 = Teach | 5 = Monitoring | ",
      ),
  ),
  courseDescription: z
    .string()
    .describe("Descrição do curso associado ao certificado.")
    .nullish(),
  disciplineName: z
    .string()
    .describe("Nome da disciplina associada ao certificado. Opcional.")
    .nullish(),
  dateStart: z
    .string()
    .datetime()
    .describe(
      "Data de início do curso ou atividade relacionada ao certificado. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<CertificateIssuedViewModel>;
